/* import __COLOCATED_TEMPLATE__ from './headers.hbs'; */
/* RESPONSIBLE TEAM: team-actions */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { isPresent } from '@ember/utils';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import safeWindowOpen from 'embercom/lib/safe-window-open';
import type Store from '@ember-data/store';
import type RouterService from '@ember/routing/router-service';
import type IntlService from 'ember-intl/services/intl';
import type Token from 'embercom/models/custom-authentication/token';

interface TokenGroup {
  items: { value: string; text: string }[];
}

interface Args {
  tokenList: TokenGroup[];
  selectedToken?: Token;
  updateSelectedToken: (tokenId: string) => void;
  clearSelectedToken: () => void;
}

interface Signature {
  Element: HTMLElement;
  Args: Args;
}

interface FooterAction {
  text: string;
  icon: string;
  action: () => void;
}

export default class Headers extends Component<Signature> {
  @service declare store: Store;
  @service declare router: RouterService;
  @service declare intl: IntlService;

  @tracked isAddingAuthHeader = false;

  get tokenFooterActions(): FooterAction[] {
    return [
      {
        text: this.intl.t('standalone.deploy.api.authentication.new-label'),
        icon: 'new',
        action: () =>
          safeWindowOpen(this.router.urlFor('apps.app.settings.app-settings.authentication.new')),
      },
      {
        text: this.intl.t('standalone.deploy.api.authentication.manage-tokens'),
        icon: 'settings',
        action: () =>
          safeWindowOpen(this.router.urlFor('apps.app.settings.app-settings.authentication')),
      },
    ];
  }

  get showAuthHeader(): boolean {
    return isPresent(this.args.selectedToken) || this.isAddingAuthHeader;
  }

  @action
  startAddingAuthHeader(): void {
    this.isAddingAuthHeader = true;
  }

  @action
  clearSelectedToken(): void {
    this.isAddingAuthHeader = false;
    this.args.clearSelectedToken();
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Api::Headers': typeof Headers;
    'standalone/api/headers': typeof Headers;
  }
}
